import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { VideoSection } from '../components/VideoSection';
import { BonusSection } from '../components/BonusSection';
import { CertificateSection } from '../components/CertificateSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-302">
      <HeroSection data-id="element-303" />
      <ProblemSection data-id="element-304" />
      <SolutionSection data-id="element-305" />
      <ContentSection data-id="element-306" />
      <VideoSection data-id="element-307" />
      <BonusSection data-id="element-308" />
      <CertificateSection data-id="element-309" />
      <OrderBumpSection data-id="element-310" />
      <PricingSection data-id="element-311" />
      <TestimonialsSection data-id="element-312" />
      <FAQSection data-id="element-313" />
      <SocialProofPopup data-id="element-314" />
      <WhatsAppButton data-id="element-315" />
    </main>;
}